/**
 * CONF-221. Which flash media a selected SSD part is — TLC or QLC.
 *
 * Read from the part's registry entry (`mediaType` on
 * capabilities.productMappings.afaSsd / hybridSsd), the same row the
 * dropdown offers and the BOM books, so the metrics layer cannot disagree
 * with the catalog. Not derived from capacity (30.72TB ships as both) and
 * not from the part-number suffix. An entry with no declaration, an unknown
 * part or no part at all is TLC: the default every quote carried before QLC
 * existed. QLC write throughput is capped from this — see
 * metrics/shared/performanceHelpers resolveNetworkThroughput.
 */
import { getVendor } from '../config/vendorRegistry';
import { DRIVE_TYPES } from './partNumbers';

export const ssdMediaType = (vendorId, partNumber) => {
  if (!partNumber) return DRIVE_TYPES.SSD_TLC;
  const pMap = getVendor(vendorId)?.capabilities?.productMappings;
  const entry = [...(pMap?.afaSsd || []), ...(pMap?.hybridSsd || [])]
    .find((m) => m.partNumber === partNumber);
  return entry?.mediaType === DRIVE_TYPES.SSD_QLC ? DRIVE_TYPES.SSD_QLC : DRIVE_TYPES.SSD_TLC;
};
